<template>
  <div class="card">
    <div class="card-header">
      <div class="icon-container">
        <i class="icon fa-light fa-file-audio"></i>
      </div>
      <div class="title-container">
        <h5
          class="title-large-semibold header-lg"
          v-html="transcriptionZoom?.title"
        ></h5>
      </div>
      <div class="tag-container">
        <GenericTag
          v-if="transcriptionZoom?.ongoing"
          backgroundColor="#22D3EE33"
          isPill
          class="tag"
        >
          <LiveTag />
        </GenericTag>
        <GenericTag v-else backgroundColor="#22D3EE33" isPill class="tag">
          <span class="title-small-semibold">{{
            getDateShortFormat(transcriptionZoom?.created_at)
          }}</span>
        </GenericTag>
        <GenericTag backgroundColor="#22D3EE33" isPill class="tag">
          <InstitutionBadge
            :institution="
              getInstitutionsNames(transcriptionZoom?.source as InstitutionKey)
            "
          />
          <span class="title-small-semibold">{{
            getInstitutionsNames(transcriptionZoom?.source as InstitutionKey)
          }}</span>
        </GenericTag>
      </div>
    </div>
    <div class="card-header header-md">
      <h5 class="title-large-semibold">
        {{ transcriptionZoom?.title }}
      </h5>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useTranscriptionsStore } from "@/follaw-fr/stores/transcriptions";
import GenericTag from "../../reusable/atoms/GenericTag.vue";
import { getDateShortFormat } from "@/follaw-fr/utils/formatDate";
import LiveTag from "../atoms/LiveTag.vue";
import {
  getInstitutionsNames,
  type InstitutionKey,
} from "@/follaw-fr/utils/institutions.utils";
import InstitutionBadge from "../../legi-work/atoms/InstitutionBadge.vue";
const { transcriptionZoom } = storeToRefs(useTranscriptionsStore());

type TranscriptionZoomHeaderProps = Partial<{
  created_at: string | null;
  source: string | null;
  title: string | null;
  ongoing: boolean | null;
}>;

defineProps<TranscriptionZoomHeaderProps>();
</script>

<style scoped lang="scss">
.card {
  display: flex;
  flex-direction: column;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  gap: 15px;
}

.icon-container {
  flex-shrink: 0;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  color: white;
  background-color: var(--clr-service-transcription);
}

.tag {
  text-align: center;
  padding: 5px 10px;
  gap: 12px;
}

.tag-container {
  display: flex;
  align-self: flex-start;
  justify-content: flex-end;
  padding-bottom: 5px;
  gap: 8px;
}

.title-container {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.card-content {
  display: flex;
  justify-content: center;
  padding: 15px;
}

.header-lg {
  display: block;
  text-align: justify;
}
.header-md {
  display: none;
}

@media screen and (max-width: 992px) {
  .header-lg {
    display: none;
  }
  .header-md {
    display: block;
    text-align: center;
  }
}
</style>
